import React from 'react';
import { HelpCenterLvl_2_1 } from '../../utils/constant';
import HelpCenterTemplate from '../../components/HelpCenterComponents/HelpCenterTemplate';

const GettingStarted = () => {
  return (
    <HelpCenterTemplate
      pageTitle="Getting Started with Spatial Grid"
      sectionTitle="Understanding Spatial Grid & Business Value"
      sectionDescription="Get started"
      articlesData={HelpCenterLvl_2_1}
      basePath="/help-center/getting-started-articles"
      breadcrumbPath={{
        name: 'Getting Started',
        path: '/help-center/getting-started',
      }}
      searchPlaceholder="Search the Spatial Grid Help Center"
      showArticleCount={true}
      maxDisplayArticles={9}
      seeAllLink="/help-center/getting-started-articles"
    />
  );
};

export default GettingStarted;
